module.exports = __webpack_public_path__ + "static/media/SWSCRC1-12.332d2d91.mp3";